import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useAuth } from "./useAuth";
import { useCookies } from "react-cookie";
import { paths } from "../types/Defaults";
import { Button } from "react-bootstrap";

type StikyContextType = {
  setShowSticky: (show: boolean) => void;
};

const stikyContext = createContext<StikyContextType | undefined>(undefined);

export const StickyProvider = ({ children }: any) => {
  const [, setCookie] = useCookies(["signUpCTA"]);
  const [showSticky, setShowSticky] = useState(false);

  const ctx = useMemo(() => ({ setShowSticky }), []);
  const { isLogged } = useAuth();

  const actionHandler = () => {
    // eventBus.dispatch("show-user-login-box", true);

    setShowSticky(false);
  };

  const handleHide = useCallback(() => {
    setCookie("signUpCTA", false);
    setShowSticky(false);
  }, [setCookie]);

  return (
    <stikyContext.Provider value={ctx}>
      {children}
      {showSticky && !isLogged && (
        <div className="stikyCTA">
          <div className="stikyCTA__body">
            <span className="stikyCTA__body__closeIcon" onClick={handleHide}>
              <i className="bi bi-x"></i>
            </span>
            <i className="bi bi-lightbulb-fill" style={{ color: "yellow" }}></i>
            <div className="stikyCTA__body__separator"></div>
            <p>
              Ready to finally get returns above the benchmarks? Join for free
              and explore AI-powered portfolios trusted by smart family offices.
              Learn how to maximize your returns and minimize your fees!
            </p>
            <Button
              className="highlightedSignupButton"
              onClick={actionHandler}
              href={paths.externalHome + "#subscribe"}
            >
              Sign Up
            </Button>
          </div>
        </div>
      )}
    </stikyContext.Provider>
  );
};

const useStikyMessage = () => {
  return useContext(stikyContext);
};

export const useShowStickyOnMount = () => {
  const [cookie] = useCookies(["signUpCTA"]);

  const ctx = useStikyMessage();

  useEffect(() => {
    const visible = cookie?.["signUpCTA"] === "false" ? false : true;
    ctx?.setShowSticky(visible);
    return () => {
      ctx?.setShowSticky(false);
    };
  }, [cookie, ctx]);
};
